import script from "./hype-component.vue?vue&type=script&lang=js"
export * from "./hype-component.vue?vue&type=script&lang=js"

import "./hype-component.vue?vue&type=style&index=0&id=16c8c4a9&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c8c4a9"]])

export default __exports__